import React, { useState } from "react";
import { toast } from "react-toastify";
import axios from "axios";
import { API_URL } from '../config/api';
import BRANDING from "../config/branding";

const CreateUserPage = () => {
	const [email, setEmail] = useState("");
	const [fullName, setFullName] = useState("");
	const [role, setRole] = useState("");
	const [password, setPassword] = useState("");

	const currentRole = localStorage.getItem("role");

	const handleCreateUser = async (e) => {
		e.preventDefault();

		try {
			const payload = {
				email,
				role,
				password,
				full_name: fullName,
			};

			const token = localStorage.getItem("token");

			const response = await axios.post(
				`${API_URL}/create_user.php`,
				payload,
				{
					headers: {
						Authorization: `Bearer ${token}`,
						"Content-Type": "application/json",
					},
				}
			);

			if (response.data.status) {
				toast.success("User created successfully!");
				 // Clear form
            setFullName("");
            setEmail("");
            setPassword("");
            setRole("");
			} else {
				toast.error(response.data.message || "Failed to create user.");
			}
		} catch (error) {
			toast.error("An error occurred. Please try again later.");
		}
	};

	const allowedRoles = [
		{ value: "admin", label: "Admin" },
		{ value: "customer_support", label: "Customer Support" },
	];

	if (currentRole === "super_admin") {
		allowedRoles.unshift({ value: "super_admin", label: "Super Admin" });
	}

	return (
		<div className='w-full'>
			<div className='max-w-2xl mx-auto bg-white p-8 rounded-2xl border border-slate-200 shadow-sm'>

				<div className='mb-8'>

					<div className='flex justify-center mb-6'>
	<img
		src={BRANDING.logo}
		alt={BRANDING.shortName}
		className='h-16 w-auto object-contain'
	/>
</div>
					<h2
	className='text-3xl font-bold flex justify-center'
	style={{ color: BRANDING.primaryColor }}
>
	Create User
</h2>

					<p className='text-slate-500 mt-2 flex justify-center'>
						Create and manage RedPay platform users and access permissions
					</p>
				</div>
				<form onSubmit={handleCreateUser} className='space-y-6'>
					<div>
						<label className='block text-sm font-semibold text-slate-700'>
							Full Name
						</label>
						<input
							type='text'
							id='fullname'
							value={fullName}
							onChange={(e) => setFullName(e.target.value)}
							className='w-full p-3 mt-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-600
focus:border-red-600'
							required
						/>
					</div>
					<div>
						<label htmlFor='email' className='block text-sm font-semibold text-slate-700'>
							Email
						</label>
						<input
							type='email'
							id='email'
							value={email}
							onChange={(e) => setEmail(e.target.value)}
							className='w-full p-3 mt-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-600
focus:border-red-600'
							required
						/>
					</div>
					<div>
						<label htmlFor='password' className='block text-sm font-semibold text-slate-700'>
							Password
						</label>
						<input
							type='password'
							id='password'
							value={password}
							onChange={(e) => setPassword(e.target.value)}
							className='w-full p-3 mt-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-600
focus:border-red-600'
							required
						/>
					</div>

					<div>


						<label htmlFor='role' className='block text-sm font-semibold text-slate-700'>
							Role
						</label>
						<select
							id='role'
							value={role}
							onChange={(e) => setRole(e.target.value)}
							className='w-full p-3 mt-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-600
focus:border-red-600'
							required
						>
							<option value=''>Select Role</option>
							{allowedRoles.map((r) => (
								<option key={r.value} value={r.value}>
									{r.label}
								</option>
							))}
						</select>
					</div>
					<button
    type='submit'
    className='
        w-full
        py-3
        mt-4
       bg-red-600
        text-white
        font-semibold
        rounded-lg
        hover:bg-red-700
        transition
        duration-200
    '
>
    Create User
</button>
				</form>
			</div>
		</div>
	);
};

export default CreateUserPage;
